import React from "react";
import OwnLocationItem from "../../components/OwnLocationItem";
import Dimension from "../../models/Dimension";
import LocationInfo from "../../models/LocationInfo";
import DimensionsService from "../../services/DimensionsService"
import Tile from "./components/Tile";
import {Link, useNavigate} from "react-router-dom";
import {Button, Accordion, Breadcrumb, Container, Row, Col} from 'react-bootstrap';
import {BsFillPlusCircleFill} from 'react-icons/bs';

const EditDimensionLocations: React.FC<{data: Dimension, reloadDimension: ()=>void}> = (props) => {
    let navigate = useNavigate();
    const [clusters, setClusters] = React.useState<any>({});
    const [currentCluster, setCurrentCluster] = React.useState<any>({});
    const [path, setPath] = React.useState<string>('');
    const [unclustered, setUnclustered] = React.useState<string[]>([]);

    function createNewLocation() {
        let name = window.prompt("Enter new location name");
        if (!name) {
            return;
        }
        DimensionsService.createLocation(props.data.id, name, path)
        .then((data: LocationInfo)=>{
            props.reloadDimension();
        })
        .catch((error: string)=>{ console.error(`Failed to create new location: ${error}`)});
    }

    React.useEffect(() => {
        DimensionsService.getLocationClusters('dev', props.data.id)
        .then((data: any)=>{
            //setPath('')
            setClusters(prepareData(data))
            setUnclustered(prepareUnclustered(data))
        })
        .catch((error: string)=>{ console.error(`Failed to get location clusters: ${error}`)});
    }, [props.data])


    React.useEffect(() => {
        if (path == '') {
            setCurrentCluster(clusters)
        } else {
            let current = clusters
            for (const key of path.split('/')) {
                current = current[key]
            }
            setCurrentCluster(current)
        }
    }, [clusters, path])

    function addDataNode(tree: any, path: string[], index: number, locations: string[]) {
        if (index == path.length) {
            for (const loc of locations) {
                tree[loc] = { _location_: true }
            }
            return
        }

        let key = path[index]
        if (!tree[key]) {
            tree[key] = {}
        }
        addDataNode(tree[key], path, index+1, locations)
    }

    function prepareData(data: any) {
        let result = {}
        for (const [key, value] of Object.entries(data)) {
            if (value) {
                addDataNode(result, key.split('/'), 0, value as string[])
            }
        }
        return result
    }

    function prepareUnclustered(data: any) {
        let set = new Set()
        for (const [key, value] of Object.entries(data)) {
            if (value) {
                for (const id of value as string[]) {
                    set.add(id)
                }
            }
        }
        let result: string[] = []
        for (const item of props.data.locations) {
            if (!set.has(item.id)) {
                result.push(item.id)
            }
        }
        return result
    }

/*
    <div className="d-flex flex-column">
        {props.data.locations && props.data.locations!.map((item, idx) => {
            return (<OwnLocationItem key={idx} dimId={props.data.id} data={item}/>);
        })}
    </div>
*/

    return (
        <>
            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} onClick={() => setPath('')}>
                    Clusters
                </Breadcrumb.Item>
                { path.split('/').map((item, idx) => {
                    let target = path.split('/').slice(0, idx+1).join('/')
                    return (
                        <Breadcrumb.Item linkAs={Link} onClick={() => setPath(target)} active = {idx == path.split('/').length - 1} key={idx}>
                            {item}
                        </Breadcrumb.Item>
                    )
                })}
            </Breadcrumb>

            <Button variant="primary" onClick={createNewLocation} style={{ marginBottom: 'var(--margin-half)' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    <BsFillPlusCircleFill size={24} style={{ marginRight: '8px' }} />
                    Create New Location
                </span>
            </Button>

            <div className="d-flex flex-column">
                <Row>
                    {Object.keys(currentCluster).map((key, idx) => {
                        let item = currentCluster[key]
                        let target = path ? `${path}/${key}` : key
                        return (
                            <Col xs={6} sm={6} md={4} lg={3} key={idx}>
                                <Tile type={item._location_ ? 'location' : 'cluster'}
                                    text={props.data.locationsMap[key] ? props.data.locationsMap[key].name : key}
                                    onClick={()=>{
                                        if (item._location_) {
                                            navigate(`/edit-location?dim=${props.data.id}&loc=${key}`);
                                        } else {
                                            setPath(`${target}`)
                                            console.log(`CLICKED: ${target}`)
                                        }
                                    }}/>
                            </Col>
                        )
                    })}
                </Row>
                { path == '' && unclustered.length > 0 && (
                    <Row>
                        { unclustered.map((key, idx) => {
                            return (
                                <Col xs={6} sm={6} md={4} lg={3} key={idx}>
                                    <Tile type='location'
                                        text={props.data.locationsMap[key].name}
                                        onClick={()=>{
                                            navigate(`/edit-location?dim=${props.data.id}&loc=${key}`);
                                        }}/>
                                </Col>
                            )})
                        }
                    </Row>
                )}
            </div>
        </>
    );
};

export default EditDimensionLocations;
